import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsSkipPreviousFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M8.12 11.96L19.04 5.16V18.76L8.12 11.96ZM3.7 5.32H6.86V18.6H3.7V5.32Z" />
    </SvgIcon>
  );
});
